import moment from "moment-timezone";

export const FUSO_BRASILIA = "America/Sao_Paulo";

export const QUANDO_AGORA = "agora";
export const QUANDO_AGENDAR = "agendar";

export const STATUS_AGENDAMENTO = {
  AGENDADA: { texto: "Agendada", cor: "primary" },
  PROCESSANDO: { texto: "Processando", cor: "warning" },
  ENVIADA: { texto: "Enviada", cor: "success" },
  CANCELADA: { texto: "Cancelada", cor: "grey" },
  FALHA: { texto: "Falha", cor: "error" }
};

export const MENSAGEM_EM_PROCESSAMENTO =
  "O envio está em processamento e não pode ser alterado ou cancelado.";

export const statusAgendamento = status =>
  STATUS_AGENDAMENTO[status] || { texto: status || "-", cor: "grey" };

// editar, reagendar e cancelar so antes do inicio do processamento
export const podeAlterarAgendamento = status => status === "AGENDADA";

export const origemEnvio = idagendamento =>
  idagendamento ? "Agendado" : "Imediato";

/**
 * Valida data (AAAA-MM-DD) e hora (HH:mm) no horario de Brasilia.
 * Devolve um objeto com a mensagem de cada campo a corrigir; vazio quando valido.
 */
export const validarDataHoraAgendamento = (data, hora, agora = moment()) => {
  const erros = {};
  if (!data) erros.data = "Informe a data do envio.";
  if (!hora) erros.hora = "Informe o horário do envio.";
  if (data && !moment(data, "YYYY-MM-DD", true).isValid()) {
    erros.data = "Data inválida.";
  }
  if (hora && !moment(hora, "HH:mm", true).isValid()) {
    erros.hora = "Horário inválido.";
  }
  if (Object.keys(erros).length) return erros;

  const instante = moment.tz(
    `${data} ${hora}`,
    "YYYY-MM-DD HH:mm",
    true,
    FUSO_BRASILIA
  );
  if (!instante.isAfter(agora)) {
    erros.data = "Informe uma data e horário futuros (horário de Brasília).";
    erros.hora = "Informe uma data e horário futuros.";
  }
  return erros;
};

// instante UTC vindo da API -> data e hora de Brasilia para o formulario
export const separarDataHoraBrasilia = iso => {
  if (!iso) return { data: "", hora: "" };
  const m = moment.tz(iso, FUSO_BRASILIA);
  return { data: m.format("YYYY-MM-DD"), hora: m.format("HH:mm") };
};

export const formatarDataHoraBrasilia = iso =>
  iso ? moment.tz(iso, FUSO_BRASILIA).format("DD/MM/YYYY HH:mm") : "-";

export const hojeBrasilia = () => moment.tz(FUSO_BRASILIA).format("YYYY-MM-DD");

export const CANAL_TEXTO = {
  app: "Aplicativo",
  web: "Web Push",
  ambos: "Aplicativo + Web Push"
};
